import * as actions from 'redux/constants';
import { HOSTED_PAGE_TYPES, STATUSES } from 'consts';
import { getDefaultMessages, iframeMessages } from 'services/iframeService';
import { isResetPINErrorUnexpected } from 'utilities';

const {
  sendGetPageFailMsg: sendGetResetPINPageFailMsg,
  sendStartMsg: sendResetPINPageActionStartMsg,
  sendSuccessMsg: sendResetPINActionSuccessMsg,
  sendFailMsg: sendResetPINActionFailedMsg
} = getDefaultMessages(HOSTED_PAGE_TYPES.cardIssuingResetPIN);

const resetPINMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.GET_RESET_PIN_PAGE_FAIL: {
      sendGetResetPINPageFailMsg(action.payload.error);
      break;
    }
    case actions.GET_RESET_PIN_PAGE_SUCCESS: {
      const { status } = action.payload.data;
      if (status !== STATUSES.new) {
        sendGetResetPINPageFailMsg('RESET_PIN_PAGE_ALREADY_IN_USE');
      }
      break;
    }
    case actions.RESET_PIN_START: {
      sendResetPINPageActionStartMsg();
      break;
    }
    case actions.RESET_PIN_SUCCESS: {
      const {
        data: {
          ewallet_contact: ewalletContact,
          card_id: cardId,
          assigned_at: assignedAt,
          activated_at: activatedAt,
          created_at: createdAt,
          card_program: cardProgram
        }
      } = action.payload;

      const resetPinSuccessEventData = {
        ewallet_contact: ewalletContact || null,
        card_id: cardId || null,
        assigned_at: assignedAt || null,
        activated_at: activatedAt || null,
        created_at: createdAt || null,
        card_program: cardProgram || null
      };

      sendResetPINActionSuccessMsg({
        eventType: iframeMessages.RESET_PIN_SUCCESS,
        data: resetPinSuccessEventData,
        meta: { closeIframe: true }
      });
      break;
    }
    case actions.RESET_PIN_FAIL: {
      const { error } = action.payload;
      sendResetPINActionFailedMsg({
        eventType: iframeMessages.RESET_PIN_FAIL,
        error,
        meta: { closeIframe: isResetPINErrorUnexpected(error) }
      });
      break;
    }
  }

  next(action);
};

export default resetPINMiddleware;
